import { createReducer } from "reduxsauce"
import createActions from "helpers/actionCreator"
import { computeUpdatedFilters } from "helpers/filters"
import { NORMALIZATION, removeUnsupportedFilters, removeUnsupportedAddedFilters } from "helpers/segments"
import { Types as BaseTypes } from "modules/portfolio-root/model"
import { isGroupedByMembership } from "helpers/rollups"
import { ANALYZE_SECTION, createAnalyzeGroupingAndFilterReducer } from "helpers/analyze"

export const { Types, Creators } = createActions("ompnt/modules/asset-analytics", {
  setGrouping: {
    props: ["grouping"],
    track: true,
    trackType: "asset-grouping-option-selected",
    trackPayload: ({ grouping }) => {
      let by
      if (grouping) {
        by = grouping.classificationId
          ? `${grouping.classificationId} - ${grouping.id}` : grouping.id
      }
      return { by }
    },
  },
  setNormalization: {
    props: ["normalization"],
    track: true,
    trackType: "asset-normalization-selection",
    trackPayload: ({ normalization }) => ({ normalization }),
  },
  toggleFilters: [],
  toggleShowNotHeld: {
    props: ["value"],
    track: true,
    trackType: "asset-toggle-not-held",
    trackPayload: ({ value }) => value,
  },
  updateFilters: {
    props: ["filter"],
    track: true,
    trackType: "asset-segment-filters-updated",
    trackPayload: ({ filter }) => ({ filter }),
  },
})

const INITIAL_STATE = {
  filter: null,
  filtersVisible: false,
  grouping: null,
  normalization: NORMALIZATION.CONTRIBUTION,
}

function handleUpdateFilters(state, { filter }) {
  return { ...state, ...computeUpdatedFilters(filter) }
}

function handleSetGrouping(state, { grouping }) {
  return { ...state, grouping }
}

function handleSetNormalization(state, { normalization }) {
  return { ...state, normalization }
}

function handleToggleFilters(state) {
  return { ...state, filtersVisible: !state.filtersVisible }
}

function handleToggleShowNotHeld(state, { value }) {
  return { ...state, showNotHeld: value, page: 0 }
}

function handleSetSelectedBase(state, { selectedBase }) {
  let newGrouping = state.grouping
  const newFilter = removeUnsupportedFilters(state.filter, !!selectedBase, state.normalization)
  const newAddedFilters = removeUnsupportedAddedFilters(state.addedFilters, !!selectedBase, state.normalization)
  if (selectedBase) {
    if (isGroupedByMembership(newGrouping)) {
      newGrouping = null
    }
  }
  return { ...state, grouping: newGrouping, filter: newFilter, addedFilters: newAddedFilters }
}

export const HANDLERS = {
  [Types.UPDATE_FILTERS]: handleUpdateFilters,
  [Types.SET_GROUPING]: handleSetGrouping,
  [Types.SET_NORMALIZATION]: handleSetNormalization,
  [Types.TOGGLE_FILTERS]: handleToggleFilters,
  [Types.TOGGLE_SHOW_NOT_HELD]: handleToggleShowNotHeld,
  [BaseTypes.SET_SELECTED_BASE]: handleSetSelectedBase,
  ...createAnalyzeGroupingAndFilterReducer(ANALYZE_SECTION.ASSETS),
}

export default createReducer(INITIAL_STATE, HANDLERS)
